import {
  Box,
  Card,
  CardHeader,
  IconButton,
  Stack,
  Tab,
  Tabs,
  Tooltip,
} from "@mui/material";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialButton from "../../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import Grid from "@mui/material/Grid2";
import MaterialBox from "../../../components/MaterialBox";
import RefreshIcon from "@mui/icons-material/Refresh";
import VisibilityIcon from "@mui/icons-material/Visibility";
import MaterialInput from "../../../components/MaterialInput";
import { useEffect, useState } from "react";
import MaterialDataGrid from "../../../components/MaterialDataGrid";
import { useNavigate } from "react-router-dom";
import FeedbackForm from "./feedbackForm";
import { FeedbackSharp } from "@mui/icons-material";
import EditIcon from "@mui/icons-material/Edit";
import request from "graphql-request";
import BASEURL from "../../../pages/Utils/Baseurl";
import { allReceivedSample, allYetToReceiveSample } from "./graphQL";
import PageLoading from "../../../components/Loading/PageLoading";
import Swal from "sweetalert2";
import RoleAccess from "../../function/RoleAccess";

const SamplesAndFeedback = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [formState, setFormState] = useState(null);

  const [tabValue, setTabValue] = useState(0);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [sampleData, setSampleData] = useState([]);

  //useEffect to switch tabs and API Function
  useEffect(() => {
    if (tabValue === 0) {
      fetchReceivedSampleTableData();
    } else if (tabValue === 1) {
      fetchYetToReceiveSampleTableData();
    }
  }, [tabValue]);

  //Date Filter
  const filteredData = sampleData.filter((item) => {
    if (!fromDate || !toDate) return true;

    const providedDate = new Date(item.sampleProvidedDate);
    const from = new Date(fromDate);
    const to = new Date(toDate);

    return providedDate >= from && providedDate <= to;
  });

  //Table Mapping
  const sampleList = {
    columns: [
      {
        headerName: "S.No",
        field: "sno",
        name: "S.NO",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Customer",
        field: "customerName",
        name: "customerName",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Quantity",
        field: "quantityProvided",
        name: "quantityProvided",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Provided Date",
        field: "sampleProvidedDate",
        name: "sampleProvidedDate",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Created By",
        field: "createdBy",
        name: "createdBy",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Created On",
        field: "createdOn",
        name: "createdOn",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },

      {
        headerName: "Action",
        field: "Action",
        name: "Action",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
    ],
    rows: filteredData.map((value, index) => ({
      id: value.id,
      sno: index + 1,
      sampleProvidedDate: value?.sampleProvidedDate,
      quantityProvided: value?.quantityProvided,
      customerName: value?.customer.customerName,
      createdBy: value?.createdBy?.employeeName,
      createdOn: value?.createdAt?.slice(0,10),
      Action: (
        <div
          style={{
            display: "flex",
            marginTop: "10px",
            alignItems: "center",
          }}
        >
          <RoleAccess
            modelName="Sample and Feedback Screen"
            component="ViewSample"
          >
            <Tooltip title="View Sample">
              <VisibilityIcon
                fontSize="small"
                className="actionIcon"
                onClick={() =>
                  navigate(`/samples-and-feedback/sample-Form`, {
                    state: { type: "view", data: value?.id, rowId: value?.id },
                  })
                }
              />
            </Tooltip>
          </RoleAccess>
          <RoleAccess
            modelName="Sample and Feedback Screen"
            component="UpdateSample"
          >
            <Tooltip title="Edit Sample">
              <EditIcon
                fontSize="small"
                className="actionIcon"
                onClick={() =>
                  navigate(`/samples-and-feedback/sample-Form`, {
                    state: { type: "edit", data: value?.id, rowId: value?.id },
                  })
                }
              />
            </Tooltip>
          </RoleAccess>
          <RoleAccess
            modelName="Sample and Feedback Screen"
            component="DeleteSample"
          >
            <Tooltip title="Feedback">
              <FeedbackSharp
                fontSize="small"
                className="actionIcon"
                onClick={() => {
                  setFormState({
                    type: "view",
                    data: value?.id,
                    rowId: value?.id,
                  });
                  setDialogOpen(true);
                }}
              />
            </Tooltip>
          </RoleAccess>
        </div>
      ),
    })),
  };

  //handle change for Tab change
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  //Received Tab data API Call
  const fetchReceivedSampleTableData = async () => {
    try {
      setIsLoading(true);
      const response = await request(BASEURL, allReceivedSample);

      const responseData = response.getReceivedProductSamples.data;
      const successStatus = response.getReceivedProductSamples.success;
      const responseMessage = response.getReceivedProductSamples.message;
      setSampleData(responseData);
      if (!successStatus) {
        Swal.fire({
          position: "top",
          icon: "error",
          title: responseMessage,
          showConfirmButton: true,
        });
      }
    } catch (error) {
      console.error("Error Fetching Data: ", error);
    } finally {
      setIsLoading(false);
    }
  };

  //Yet To Recieve Tab Data API Call
  const fetchYetToReceiveSampleTableData = async () => {
    try {
      const response = await request(BASEURL, allYetToReceiveSample);
      const responseData = response.getPendingProductSamples.data;
      setSampleData(responseData);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  //Download as Excel
  const exportToCSV = () => {
    const keysToExclude = ["id", "action", "user"];

    // Filter keys (headers)
    const headers = Object.keys(sampleData[0]).filter(
      (key) => !keysToExclude.includes(key)
    );

    const csvHeader = headers.join(",") + "\n";

    // Build rows with only allowed keys
    const csvRows = sampleData
      .map((row) => headers.map((header) => row[header]).join(","))
      .join("\n");

    const csvContent = csvHeader + csvRows;

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "Sample_List.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Show alert after a brief delay
    setTimeout(() => {
      Swal.fire({
        position: "top",
        icon: "success",
        title: "Sample Excel Downloaded Successfully",
        showConfirmButton: true,
      });
    }, 500); // slight delay to allow download to trigger
  };

  return (
    <DashboardLayout>
      <FeedbackForm
        open={dialogOpen}
        setOpen={setDialogOpen}
        rowId={formState}
        fetchYetToReceiveSampleTableData={fetchYetToReceiveSampleTableData}
      />
      <Card>
        <CardHeader
          title={
            <>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
              >
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Samples and Feedback List
                  </MaterialTypography>
                </Stack>
                <Box
                  display="flex"
                  justifyContent="flex-end"
                  alignItems="center"
                >
                  <RoleAccess
                    modelName="Sample and Feedback Screen"
                    component="ExportSample"
                  >
                    {sampleData.length > 0 && (
                      <button
                        className="container-btn-file"
                        onClick={exportToCSV}
                        style={{
                          height: "38px",
                          marginLeft: "0",
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                          fontSize: "14px",
                          marginRight: "20px",
                        }}
                      >
                        <svg
                          fill="#fff"
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 50 50"
                        >
                          <path d="M28.8125 .03125L.8125 5.34375C.339844 5.433594 0 5.863281 0 6.34375L0 43.65625C0 44.136719 .339844 44.566406 .8125 44.65625L28.8125 49.96875C28.875 49.980469 28.9375 50 29 50C29.230469 50 29.445313 49.929688 29.625 49.78125C29.855469 49.589844 30 49.296875 30 49L30 1C30 .703125 29.855469 .410156 29.625 .21875C29.394531 .0273438 29.105469 -.0234375 28.8125 .03125ZM32 6L32 13L34 13L34 15L32 15L32 20L34 20L34 22L32 22L32 27L34 27L34 29L32 29L32 35L34 35L34 37L32 37L32 44L47 44C48.101563 44 49 43.101563 49 42L49 8C49 6.898438 48.101563 6 47 6ZM36 13L44 13L44 15L36 15ZM6.6875 15.6875L11.8125 15.6875L14.5 21.28125C14.710938 21.722656 14.898438 22.265625 15.0625 22.875L15.09375 22.875C15.199219 22.511719 15.402344 21.941406 15.6875 21.21875L18.65625 15.6875L23.34375 15.6875L17.75 24.9375L23.5 34.375L18.53125 34.375L15.28125 28.28125C15.160156 28.054688 15.035156 27.636719 14.90625 27.03125L14.875 27.03125C14.8125 27.316406 14.664063 27.761719 14.4375 28.34375L11.1875 34.375L6.1875 34.375L12.15625 25.03125ZM36 20L44 20L44 22L36 22ZM36 27L44 27L44 29L36 29ZM36 35L44 35L44 37L36 37Z" />
                        </svg>
                        Export File
                      </button>
                    )}
                  </RoleAccess>
                  <RoleAccess
                    modelName="Sample and Feedback Screen"
                    component="CreateSample"
                  >
                    <MaterialButton
                      variant="gradient"
                      color="dark"
                      size="small"
                      startIcon={<AddIcon />}
                      onClick={() =>
                        navigate("/samples-and-feedback/sample-Form", {
                          state: { type: "add" },
                        })
                      }
                    >
                      Sample
                    </MaterialButton>
                  </RoleAccess>
                </Box>
              </Stack>
              <Grid
                container
                spacing={2}
                sx={{ width: "100%", placeItems: "center" }}
              >
                <Grid size={{ lg: 5, xs: 12, sm: 3 }}>
                  <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    TabIndicatorProps={{
                      style: {
                        backgroundColor: "#2a9941",
                        color: "white",
                      },
                    }}
                    centered
                  >
                    <Tab label="Received" />
                    <Tab label="Yet to Receive" />
                  </Tabs>
                </Grid>
                <Grid size={{ lg: 3, xs: 6, sm: 3 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      From Date <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialInput
                    type="date"
                    name="formDate"
                    value={fromDate}
                    onChange={(e) => {
                      setFromDate(e.target.value);
                    }}
                  />
                </Grid>
                <Grid size={{ lg: 3, xs: 6, sm: 3 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      To Date <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialInput
                    type="date"
                    name="endDate"
                    value={toDate}
                    onChange={(e) => {
                      setToDate(e.target.value);
                    }}
                  />
                </Grid>
                <Grid size={{ lg: 1, xs: 6, sm: 2 }}>
                  <IconButton
                    onClick={() => {
                      setFromDate("");
                      setToDate("");
                    }}
                    aria-label="Reset Filters"
                    color="primary"
                    sx={{ mt: 2 }}
                  >
                    <RefreshIcon fontSize="large" />
                  </IconButton>
                </Grid>
              </Grid>
            </>
          }
        />
        {!isLoading && (
          <MaterialDataGrid
            rows={sampleList.rows}
            columns={sampleList.columns}
          />
        )}
        {isLoading && <PageLoading />}
      </Card>
    </DashboardLayout>
  );
};

export default SamplesAndFeedback;
